var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusVectorSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55978 14.9055C5.845 15.0698 6.16854 15.1562 6.49789 15.1562C6.82724 15.1562 7.15079 15.0698 7.43601 14.9055L12.0609 12.2429C12.3461 12.0786 12.583 11.8424 12.7476 11.5579C12.9123 11.2735 12.999 10.9508 12.999 10.6223L12.999 5.29024C12.999 4.96175 12.9123 4.63905 12.7476 4.35457C12.583 4.07009 12.3461 3.83386 12.0609 3.66961L7.43601 1.00699C7.15079 0.842731 6.82724 0.756254 6.49789 0.756254C6.16854 0.756254 5.845 0.842731 5.55978 1.00699L0.937147 3.66961C0.651945 3.83386 0.415107 4.07009 0.250434 4.35457C0.0857605 4.63905 -0.000949996 4.96175 -0.000977425 5.29024L-0.000976959 10.6223C-0.000949472 10.9508 0.0857611 11.2735 0.250434 11.5579C0.415108 11.8424 0.651946 12.0786 0.937148 12.2429L5.55978 14.9055Z",
    fill: "url(#paint0_linear_1058_5959)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1058_5959",
    x1: 1.98323,
    y1: 2.72678,
    x2: 11.8828,
    y2: 11.8685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9779FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A79FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusVectorSuccess);
export default __webpack_public_path__ + "static/media/status_vector_success.ccd136bc2a56fba4493e4faa418bdc25.svg";
export { ForwardRef as ReactComponent };